export default "__VITE_ASSET__YfHmEMDX__"